import { useEffect, useState, useCallback } from "react";
import { getActivityCandidates } from "../api/activitiesApi";

export function useActivityCandidates({ date, slot, campus }) {
  const [candidateRows, setCandidateRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCandidates = useCallback(async () => {
    if (!date || !slot) {
      setCandidateRows([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await getActivityCandidates({ date, slot, campus });
      setCandidateRows(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e);
      setCandidateRows([]);
    } finally {
      setLoading(false);
    }
  }, [date, slot, campus]);

  useEffect(() => {
    fetchCandidates();
  }, [fetchCandidates]);

  return {
    candidateRows,
    loading,
    error,
    refetch: fetchCandidates,
  };
}